import React, { useState, useEffect } from 'react';
import CardTwo from './CardTwo';
import HeroSection from './HeroSection';
import Breadcrumb from './Breadcrumb';

function Testing() {
  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 768);
  const [currentCardIndex, setCurrentCardIndex] = useState(0);

  // Update `isMobileView` on window resize
  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const cardsData = [
    {
      img: '/img/testing.jpg',
      title: "Testing",
      points: [
 " Chip level testing as per standards",
  "Board level testing as per standards",
  "System level testing as per standards",
  "Testing plans",
  "Testing scenarios",
  "Testing plan and scenarios validation"
],


    },


    {
        img: '/img/integration.jpg',
        title: "Integration",
        points: [
   " Hardware integration",
    "Hardware and software integration",
    "Module level integration"
  ],
  
  
      }
  ];

  // Navigation functions for carousel
  const nextCard = () => {
    setCurrentCardIndex((prevIndex) => (prevIndex + 1) % cardsData.length);
  };

  const prevCard = () => {
    setCurrentCardIndex((prevIndex) => (prevIndex - 1 + cardsData.length) % cardsData.length);
  };

  return (
    <div>
      {/* Reusable Hero Section */}
      <HeroSection
        heading="Testing and Validation"
        backgroundImage="/img/testing1.jpg"
        punchline="Ensuring Precision and Reliability in Every Step"
      />

      <Breadcrumb />

      <div className="aboutInfo">
        <div className="container hardware">
          <div className="card2-container">
            {isMobileView
              ? // Render all cards in stacked layout for mobile view
                cardsData.map((card, index) => (
                  <CardTwo
                    key={index}
                    img={card.img}
                    title={card.title}
                    points={card.points}
                  />
                ))
              : // Render one card with navigation for larger screens
                <>
                  <button onClick={prevCard} className="arrow-button arrow-left">
                    <img src="/img/leftarrow.png" alt="Previous" />
                  </button>

                  <CardTwo
                    img={cardsData[currentCardIndex].img}
                    title={cardsData[currentCardIndex].title}
                    points={cardsData[currentCardIndex].points}
                  />

                  <button onClick={nextCard} className="arrow-button arrow-right">
                    <img src="/img/right-arrow.png" alt="Next" />
                  </button>
                </>
            }
          </div>
        </div>
      </div>
    </div>
  );
}

export default Testing;
